export const profileApiEndpoints = {
  getMe: `/admins/me`,
  updateMe: `/admins/me`,
};
